module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"CHOOSE_CONTACT":"Velg kontaktpunkt","REQUEST_PW":"Be om nytt passord"},"en":{"CHOOSE_CONTACT":"Choose point of contact","REQUEST_PW":"Request new password"}}')
  delete Component.options._Ctor
}
